import { ITranslations } from '@inter-ikea-kompis/types';
import { Action } from 'redux';
import { Localization, WriteDirection } from 'sofa-reborn-react';

// State
export interface LocalizationState {
	locale: string | null;
	writeDirection: WriteDirection;
	localization: Localization | null;
	translations: { [key: string]: string };
	kompisTranslations: ITranslations | null;
	fetchLocalizationPending: boolean;
	storeId?: string;
	zipCode?: string | null;
}

// Actions
export const SET_LOCALE = 'SET_LOCALE';
export const SET_WRITE_DIRECTION = 'SET_WRITE_DIRECTION';
export const SET_STORE_ID = 'SET_STORE_ID';
export const SET_ZIP_CODE = 'SET_ZIP_CODE';

export const FETCH_LOCALIZATION_PENDING = 'FETCH_LOCALIZATION_PENDING';
export const FETCH_LOCALIZATION_SUCCESS = 'FETCH_LOCALIZATION_SUCCESS';
export const FETCH_LOCALIZATION_FAILURE = 'FETCH_LOCALIZATION_FAILURE';
export const SET_KOMPIS_TRANSLATIONS = 'SET_KOMPIS_TRANSLATIONS';

interface SetLocale extends Action {
	type: typeof SET_LOCALE;
	value: string;
}

interface SetWriteDirection extends Action {
	type: typeof SET_WRITE_DIRECTION;
	value: WriteDirection;
}

interface SetStoreId extends Action {
	type: typeof SET_STORE_ID;
	value: string;
}

interface SetZipCode extends Action {
	type: typeof SET_ZIP_CODE;
	value: string | null;
	track: boolean;
}

interface FetchLocalizationPending extends Action {
	type: typeof FETCH_LOCALIZATION_PENDING;
}

interface FetchLocalizationSuccess extends Action {
	type: typeof FETCH_LOCALIZATION_SUCCESS;
	localization: Localization;
	// eslint-disable-next-line @typescript-eslint/ban-types
	translations: {};
}

interface FetchLocalizationFailure extends Action {
	type: typeof FETCH_LOCALIZATION_FAILURE;
}

interface SetKompisTranslations extends Action {
	type: typeof SET_KOMPIS_TRANSLATIONS;
	kompisTranslations: ITranslations;
}

export type LocalizationStateTypes =
	| SetLocale
	| SetWriteDirection
	| FetchLocalizationPending
	| FetchLocalizationSuccess
	| FetchLocalizationFailure
	| SetKompisTranslations
	| SetStoreId
	| SetZipCode;
